export default __webpack_public_path__ + "static/media/Mail.cdd2d2eb.svg";